import React, { useState, useEffect } from "react";
import {
    Grid,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Typography,
    Switch,
    TablePagination,
    Backdrop,
    CircularProgress,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import useStyles from "../../../themes/style.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Notification from "../../../components/Notification";
import { Autocomplete } from "@material-ui/lab";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const positions = [toast.POSITION.TOP_RIGHT];
export default function VendorInfo() {
    const classes = useStyles();
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token)
    const mobileQuery = useMediaQuery('(max-width:600px)');
    const location = useLocation();
    // const titlePaths = user?.role_code === "ADMIN" ? adminTitlePaths : userTitlePaths;


    const queryParams = new URLSearchParams(location.search);
    const userIdParam = queryParams.get("user_id");

    const assignSchema = Yup.object().shape({
        requirementId: Yup.string().required("Requirement Name is required"),
    });

    const {
        register: assignRequirement,
        formState: { errors: assignErrors, isSubmitting: assignIsSubmitting },
        handleSubmit: assignSubmit,
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(assignSchema),
    });

    var [notificationsPosition] = useState(2);
    var [errorToastId, setErrorToastId] = useState(null);
    const [loader, setLoader] = useState(false);
    const [requirementId, setRequirementId] = useState(null);
    const [requirementName, setRequirementName] = useState([]);
    const [assignData, setAssignData] = useState([]);
    const [assignPage, setAssignPage] = useState(0);
    const [assignCurrerntPage, setAssignCurrerntPage] = useState(1);
    const [assigncount, setAssignCount] = useState(0);

    function sendNotification(componentProps, options) {
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options,
        );
    }

    function handleNotificationCall(notificationType, message) {
        var componentProps;

        if (errorToastId && notificationType === "error") return;

        switch (notificationType) {
            case "info":
                componentProps = {
                    type: "feedback",
                    message: message,
                    variant: "contained",
                    color: "primary",
                };
                break;
            case "error":
                componentProps = {
                    type: "message",
                    message: message,
                    variant: "contained",
                    color: "secondary",
                };
                break;
            default:
                componentProps = {
                    type: "shipped",
                    message: message,
                    variant: "contained",
                    color: "success",
                };
        }

        var toastId = sendNotification(componentProps, {
            type: notificationType,
            position: positions[notificationsPosition],
            progressClassName: classes.progress,
            onClose: notificationType === "error" && (() => setErrorToastId(null)),
            className: classes.notification,
        });

        if (notificationType === "error") setErrorToastId(toastId);
    }

    const handlerequirementChangePage = (event, newPage) => {
        setAssignPage(newPage);
        setLoader(true);
        setAssignCurrerntPage(newPage + 1);

        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/viewAllAssigendRequirements`,
            data: {
                recruiterId: userIdParam,
                page: newPage + 1
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {

            if (response.data.status === true) {
                setAssignData(response.data.data);
                setAssignCount(response.data.count);
            }

            setLoader(false);
        });
    };

    function handleAssignStatus(id, value) {
        setLoader(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/changeAssignedRequirementStatus`,
            data: {
                id: id,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": token,
            },
        }).then(function (response) {

            if (response.data.status === true) {

                const switchState = assignData.map(item => {
                    if (item.id === id) {
                        return { ...item, isActive: value };

                    }
                    return item;
                });
                setAssignData(switchState);
                setLoader(false);
                handleNotificationCall("success", response.data.message);
            } else {
                handleNotificationCall("error", response.data.message);
                setLoader(false);
            }
        }).catch((err) => {
            console.log(err)
            setLoader(false);
        });
    }

    function handleAssignRequirements(values) {
        return new Promise((resolve) => {
            setLoader(true);
            axios({
                method: "post",
                url: `${process.env.REACT_APP_SERVER}admin/assignRequirements`,
                data: {
                    recruiterId: userIdParam,
                    requirementId: requirementId?.id,
                },

                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }).then(function (response) {
                resolve();
                if (response.data.status === true) {
                    handleNotificationCall("success", response.data.message);
                    getAssigendRequirements()
                    setRequirementId(null);
                } else {
                    handleNotificationCall("error", response.data.message);
                }
                setLoader(false);
            });
        });
    }

    useEffect(() => {
        getAssigendRequirements();
        getRequirementName();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRequirementName = async () => {
        let url=''

        if (decoded.role==="ADMIN") {
            url = `${process.env.REACT_APP_SERVER}admin/getAllRequirementList`
        } else if(decoded.role==="CLIENTCOORDINATOR") {
            url = `${process.env.REACT_APP_SERVER}CC/myRequirements`
        }else{
            url=""
        }

        axios({
            method: "post",
            url: url,
            data: {},
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
            .then(function (response) {
                if (response.data.status === true) {
                    setLoader(false);
                    setRequirementName(response.data.data);
                }
            })

            .catch(function (error) {
                console.log(error);
            });
    };

    function getAssigendRequirements() {

        let url=""
        if (decoded.role==="ADMIN") {
            url = `${process.env.REACT_APP_SERVER}admin/viewAllAssigendRequirements`
        } else if(decoded.role==="CLIENTCOORDINATOR") {
            url = `${process.env.REACT_APP_SERVER}CC/viewAllAssigendRequirementsCC`
        }else{
            url=""
        }

        setLoader(true);
        axios({
            method: "post",
            url: url,
            data: {
                recruiterId: userIdParam,
                page: "1",
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
            .then(function (response) {
                if (response.data.status === true) {
                    setLoader(false);
                    setAssignData(response.data.data);
                    setAssignCount(response.data.count);
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    return (
        <>
            <Grid
                container
                direction="row"
                spacing={2}
                style={{ padding: "0px 10px" }}
            >
                <Grid
                    container
                    direction="row"
                    spacing={1}
                >
                    <Grid xs={8} lg={6} >
                        <form onSubmit={assignSubmit(handleAssignRequirements)}>
                            <div style={{ display: "flex", alignItems: "end", gap: "10px", margin: "25px 0px 25px" }}>
                                <FormControl >
                                    <InputLabel shrink htmlFor="requirementId">  Requirement Name   </InputLabel>
                                    <Autocomplete
                                        options={requirementName}
                                        name="requirementId"
                                        disableClearable
                                        error={assignErrors.requirementId ? true : false}
                                        {...assignRequirement("requirementId")}
                                        getOptionLabel={(option) =>
                                            option.requirementName + " (" + option.uniqueId + ")"
                                        }
                                        onChange={(event, value) => {
                                            setRequirementId(value);
                                        }}
                                        renderInput={(params) => (
                                            <TextField   {...params} name="requirementId" variant="filled" />
                                        )}
                                    />
                                    <Typography variant="inherit" color="error" style={{ position: 'absolute', bottom: "-22px", left: 0 }}>
                                        {assignErrors.requirementId?.message}
                                    </Typography>
                                </FormControl>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={assignIsSubmitting}
                                    type="submit"

                                    className={classes.mt16}
                                >
                                    Assign
                                </Button>
                                {assignErrors.requirementId?.message || assignErrors.recruiterId?.message ? <br /> : ""}
                            </div>
                        </form>
                    </Grid>
                    <Grid xs={12}>
                        <Grid container direction="row" spacing={2}>
                            <Grid item xs={12}   >
                                <MUIDataTable
                                    title=""
                                    options={{
                                        pagination: false,
                                        sort: false,
                                        selectableRows: "none",
                                        search: false,
                                        filter: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        responsive: mobileQuery === true ? 'vertical' : 'standard',
                                        textLabels: {
                                            body: {
                                                noMatch: 'Oops! Matching record could not be found',
                                            }
                                        },
                                    }}
                                    columns={[
                                        {
                                            name: "S.No",
                                        },
                                        {
                                            name: "Requirement Name",
                                        },
                                        {
                                            name: "Status",
                                        },
                                        {
                                            name: "Posted Date",
                                        },
                                    ]}
                                    data={assignData.map((item, index) => {
                                        return [
                                            <>   {assignCurrerntPage !== 0 ? 10 * assignCurrerntPage - 10 + index + 1 : index + 1}  </>,
                                            <>   {item.requirement?.requirementName} {"(" + item.requirement?.uniqueId + ")"} </>,
                                            <Switch
                                            key={index}
                                                checked={item.isActive}
                                                onChange={(e) => {
                                                    handleAssignStatus(item.id, e.target.checked);
                                                }}
                                                color="primary"
                                                inputProps={{ "aria-label": "primary checkbox" }} />,
                                            moment(item.createdAt).format("DD-MM-YYYY"),
                                        ];
                                    })}
                                />  </Grid>
                        </Grid>
                        <Grid container spacing={2} className={classes.pagination}>
                            <TablePagination
                                rowsPerPageOptions={[50]}
                                component="div"
                                count={assigncount}
                                rowsPerPage={10}
                                page={assignPage}
                                onPageChange={handlerequirementChangePage}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Backdrop className={classes.backdrop} open={loader}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Grid>
        </>
    );
}
